import React, { useEffect, useState } from "react";

const PricingCalculator = (props) => {
  const {
    totalCostInfo
  } = props
  const [state, setState] = useState({
    unitCost: totalCostInfo || 2.53,
    casesSold: 250,
    markups: [
      { label: "27% Markup", value: 27 },
      { label: "30% Dist Markup", value: 30 },
      { label: "40% Retailer Markup", value: 40 },
    ]
  });

  useEffect(() => {
    if (totalCostInfo) {
      setState({
        ...state,
        unitCost: totalCostInfo
      })
    }
  }, [
    totalCostInfo
  ])

  const handleAddMarkup = () => {
    setState(prev => ({
      ...prev,
      markups: [...prev.markups, { label: "", value: 0 }]
    }));
  };

  const handleMarkupChange = (index, key, newValue) => {
    const newMarkups = [...state.markups];
    newMarkups[index][key] = key === "value" ? parseFloat(newValue) : newValue;
    setState(prev => ({
      ...prev,
      markups: newMarkups
    }));
  };

  const calculateRow = (markup) => {
    const profitEach = +(state.unitCost * (markup.value / 100)).toFixed(2);
    const wholesale = +(state.unitCost + profitEach).toFixed(2);
    const revenue = +(wholesale * state.casesSold).toFixed(2);
    const profit = +(profitEach * state.casesSold).toFixed(2);

    return { profitEach, wholesale, revenue, profit };
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Pricing Calculator</h2>

      <div className="mb-3">
        <label className="block font-semibold">Unit Cost:</label>
        <input
          type="number"
          value={state.unitCost}
          onChange={(e) => setState({ ...state, unitCost: parseFloat(e.target.value) })}
          className="form-control mb-2"
        />
        <label className="block font-semibold">Cases Sold:</label>
        <input
          type="number"
          value={state.casesSold}
          onChange={(e) => setState({ ...state, casesSold: parseInt(e.target.value) })}
          className="form-control"
        />
      </div>

      <table className="table table-bordered w-full text-left mt-4">
        <thead>
          <tr>
            <th>Label</th>
            <th>% Markup</th>
            <th>Profit Each</th>
            <th>Wholesale</th>
            <th>Revenue</th>
            <th>Profit</th>
          </tr>
        </thead>
        <tbody>
          {state.markups.map((markup, index) => {
            const { profitEach, wholesale, revenue, profit } = calculateRow(markup);
            return (
              <tr key={index}>
                <td>
                  <input
                    className="form-control"
                    value={markup.label}
                    onChange={(e) => handleMarkupChange(index, "label", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control"
                    value={markup.value}
                    onChange={(e) => handleMarkupChange(index, "value", e.target.value)}
                  />
                </td>
                <td>${profitEach.toFixed(2)}</td>
                <td>${wholesale.toFixed(2)}</td>
                <td>${revenue.toFixed(2)}</td>
                <td>${profit.toFixed(2)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <button onClick={handleAddMarkup} className="btn btn-primary mt-3">
        + Add Markup Row
      </button>
    </div>
  );
};

export default PricingCalculator;
